// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__WEj_Y","unreadBadge":"styles_unreadBadge__2TZ1X","modalContent":"styles_modalContent__35xRS","modal":"styles_modal__3ZMV0"};